// extracted by mini-css-extract-plugin
export default {"mbSm":"mbSm---VxqI2","mbMd":"mbMd---rv6_c"};